import React, { useState, useContext } from 'react';
import { PrenavLink } from '../prenav-link/PrenavLink';
import type { Link } from '../types';
import { Modal } from 'jl-design-system/components/modal/Modal';
import { JohnLewisQuickSignUpPermissions } from '@JohnLewisPartnership/permissions-universal-capture-component/johnlewis/QuickSignUpPermissions';

import styles from './top-links.scss';
import { EnvVarsFeaturesContext } from '../../scaffold/EnvVarsFeaturesContext';
import classNames from 'classnames';

interface TopLinksProps {
  links: Link[];
  className?: string;
}

export const TopLinks = ({ links, className }: TopLinksProps) => {
  const [showStayUpdatedModal, setShowStayUpdatedModal] = useState(false);

  const { stayUpdatedIsActive } = useContext(EnvVarsFeaturesContext);

  const openStayUpdated = () => {
    setShowStayUpdatedModal(true);
  };

  const closeStayUpdated = () => {
    setShowStayUpdatedModal(false);
  };

  const linksAdjusted = [...links];

  if (stayUpdatedIsActive) {
    linksAdjusted.push({
      name: 'Stay updated',
      onClick: openStayUpdated,
    });
  }

  return (
    <>
      <ul className={classNames(styles.links, className)}>
        {linksAdjusted.map(link => (
          <PrenavLink key={link.name || link.url} {...link}>
            {link.name}
          </PrenavLink>
        ))}
      </ul>
      {stayUpdatedIsActive && (
        <Modal
          footer={false}
          title="Sign me up for emails"
          isOpen={showStayUpdatedModal}
          onClose={closeStayUpdated}
        >
          <JohnLewisQuickSignUpPermissions />
        </Modal>
      )}
    </>
  );
};
